export default __webpack_public_path__ + "static/hero-course-7257b057232393cda53d94e11cb0e42e.jpg";